import { useFormik } from "formik";
import { campoValidationSchema } from "../validation";
import { CampoForm } from "./form";
import { useState } from "react";
import { useCampo } from "../hooks/useCampo";
import Swal from "sweetalert2";

export function CrearCampo({ onSuccess }) {
  const { createCampo } = useCampo();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      await createCampo(values);
      Swal.fire({ icon: "success", title: "Campo creado", timer: 1500 });
      onSuccess();
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: "Puede que el campo que intentes ingresar ya exista",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: {
      campo: "",
      acronimo: "",
      cosecha: "0",
      externo: "0",
    },
    onSubmit,
    validationSchema: campoValidationSchema,
  });

  return (
    <CampoForm
      values={values}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      loading={isLoading}
    />
  );
}
